<template>
  <SectionGroup gap="small">
    <div>
      <BasicButton
        :href="resume.user.href"
        target="_blank"
        rel="noreferrer"
        appearance="badge"
      >
        <InlineAlign gap="small">
          <template #start>
            <SvgIcon
              source="/images/services.svg"
              :icon="icon"
              :size="16"
            />
          </template>
          <template #default>
            <span v-text="resume.user.title" />
          </template>
        </InlineAlign>
      </BasicButton>
    </div>

    <div v-if="resume.activity">
      <BasicText weight="bold">
        {{ resume.activity.title }}<span v-if="hasActivityItems">:</span>
      </BasicText>
      <InlineList
        v-if="hasActivityItems"
        :items="resume.activity.items"
        v-slot="{ item }"
      >
        <RankedItem :item="item" target="_blank" rel="noreferrer" />
      </InlineList>
    </div>

    <div v-if="resume.subscriptions">
      <BasicText weight="bold">
        {{ resume.subscriptions.title }}:
      </BasicText>
      <InlineList
        :items="resume.subscriptions.items"
        v-slot="{ item }"
      >
        <RankedItem :item="item" target="_blank" rel="noreferrer" />
      </InlineList>
    </div>
  </SectionGroup>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import InlineAlign from 'src/components/InlineAlign/InlineAlign.vue';
  import InlineList from 'src/components/InlineList/InlineList.vue';
  import RankedItem from 'src/components/RankedItem/RankedItem.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
  import BasicText from 'src/components/text/BasicText/BasicText.vue';

  export default {
    name: 'ExternalResumeSection',
    components: { SvgIcon, InlineAlign, RankedItem, InlineList, BasicText, SectionGroup, BasicButton },
    props: {
      resume: {
        type: Object,
        required: true,
      },
      type: {
        type: String,
        required: true,
      }
    },
    computed: {
      icon() {
        return this.type ===  'habr' ? 'service-habr' : 'service-habr-qa';
      },
      hasActivityItems() {
        const { activity } = this.resume;
        if (!activity) return false;
        return activity.items && activity.items.length !== 0
      },
    }
  }
</script>